// extracted by mini-css-extract-plugin
export default {"language":"Language_language__6CN2l","button":"Language_button__WZ1L3","selected":"Language_selected__nAdGY"};